const ChartReport = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-chart-report"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-chart-report"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M8,16.5v3c0,.276-.224,.5-.5,.5s-.5-.224-.5-.5v-3c0-.276,.224-.5,.5-.5s.5,.224,.5,.5Zm7.5-2.5c-.276,0-.5,.224-.5,.5v5c0,.276,.224,.5,.5,.5s.5-.224,.5-.5v-5c0-.276-.224-.5-.5-.5Zm-4-3c-.276,0-.5,.224-.5,.5v8c0,.276,.224,.5,.5,.5s.5-.224,.5-.5V11.5c0-.276-.224-.5-.5-.5Zm10.5-1.015v9.515c0,2.481-2.019,4.5-4.5,4.5H6.5c-2.481,0-4.5-2.019-4.5-4.5V4.5C2,2.019,4.019,0,6.5,0h5.515c1.735,0,3.368,.676,4.597,1.904l3.484,3.485c1.228,1.227,1.904,2.859,1.904,4.596ZM15.904,2.611c-.552-.551-1.199-.97-1.904-1.243V6.5c0,.827,.673,1.5,1.5,1.5h5.132c-.273-.706-.693-1.353-1.244-1.904l-3.484-3.485Zm5.096,7.375c0-.334-.03-.663-.088-.985h-5.412c-1.379,0-2.5-1.122-2.5-2.5V1.088c-.322-.058-.651-.088-.985-.088H6.5c-1.93,0-3.5,1.57-3.5,3.5v15c0,1.93,1.57,3.5,3.5,3.5h11c1.93,0,3.5-1.57,3.5-3.5V9.985Z" />
    </svg>
  );
};

export default ChartReport;
